import http from '../../api/index'
// import Swiper from 'swiper'
// 错误的统一处理 handle error
const handleError = (err) => {
  console.log(err)
}
export default {
  tsHomeListAction ({commit}, pcMobile) {
    http().getHomeList(pcMobile)
      .then(data => {
        commit('tsHomeList', {data: data.content, pcMobile: pcMobile})
      }).catch(err => {
        handleError(err)
      })
  }, // 首页
  tsTVListAction ({commit}) {
    http().getTsTVList()
      .then(data => {
        commit('tsTvList', data)
      }).catch(err => {
        handleError(err)
      })
  }, // 获取tsTV列表数据
  tsTVDetailAction ({commit}, id) {
    http().getTsTVDetail(id)
      .then(data => {
        commit('tsTVdetail', data.content)
      }).catch(err => {
        handleError(err)
      })
  }, // 获取tsTV详情数据
  tsTvWorldAction ({commit}) {
    http().getTsWorldList()
      .then(data => {
        commit('tsWorldList', data.content)
      }).catch(err => {
        handleError(err)
      })
  }, // 获取tsWorld列表数据
  tsTvWorldDetailAction ({commit}, id) {
    http().getTsWorldDetail(id)
      .then(data => {
        commit('tsWorldDetail', data.content)
      }).catch(err => {
        handleError(err)
      })
  }, // 根据id获取tsWorld详情
  mainPushDetailAction ({commit}, id) {
    http().getMainPushDetail(id)
      .then(data => {
        commit('mainPushDetail', data.content)
      }).catch(err => {
        handleError(err)
      })
  }, // 主推系列详情
  multStockAction ({commit}, id) {
    http().getMultStockList(id)
      .then(data => {
        commit('multStockList', data)
      }).catch(err => {
        handleError(err)
      })
  }, // 多元碰撞列表
  multStockDetailAction ({dispatch, commit}, id) {
    http().getMultStockDetail(id)
      .then(data => {
        commit('multStockDetail', data.content)
        let mscID = data.content.mscId
        dispatch('multStockAction', mscID)
      }).catch(err => {
        handleError(err)
      })
  }, // 多元碰撞详情
  themeSeriesListAction ({commit}, id) {
    http().getThemeSeriesList(id)
      .then(data => {
        commit('themeSeriesList', data)
      }).catch(err => {
        handleError(err)
      })
  }, // 主题系列列表
  themeSeriesDetailAction ({dispatch, commit}, id) {
    http().getThemeSeriesDetail(id)
      .then(data => {
        commit('themeSeriesDetail', data.content)
        let rtcId = data.content.rtcId
        dispatch('themeSeriesListAction', rtcId)
      }).catch(err => {
        handleError(err)
      })
  }, // 主题系列详情
  columnListAction ({commit}, id) {
    http().getColumnList(id)
      .then(data => {
        commit('columnList', data.content)
      }).catch(err => {
        handleError(err)
      })
  }, // 栏目列表
  queryProductListAction ({commit}, product) {
    http().queryProductList(product)
      .then(data => {
        commit('queryProduct', data.content)
      }).catch(err => {
        handleError(err)
      })
  }, // 商品查询
  queryCondictionAction ({commit}, id) {
    http().queryColumnCondiction(id)
      .then(data => {
        commit('queryColumnCondiction', data.content)
      }).catch(err => {
        handleError(err)
      })
  }, // 查询栏目筛选条件
  getProductDetailAction ({commit}, list) {
    http().getProductDetail(list.id)
      .then(data => {
        commit('getProductDetail', data.content)
      }).catch(err => {
        handleError(err)
      })
  }, // 获取商品详情
  getProvinceAction ({commit}, list) {
    http().getProvince(list)
      .then(data => {
        commit('getProvince', data)
      }).catch(err => {
        handleError(err)
      })
  }, // 省份
  getShopListAction ({commit}, list) {
    http().getShopList(list.id, list.currentPage, list.pageSize)
      .then(data => {
        commit('getShopList', data)
      }).catch(err => {
        handleError(err)
      })
  },
  // 查询附近店铺
  getNearestShopAction ({commit}, params) {
    let {latitude, longitude, distance} = params
    let queryString = `${latitude}/${longitude}/${distance}`
    http().getNearestShop(queryString)
      .then(data => {
        commit('nearShopMutation', data)
      }).catch(err => {
        handleError(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/actions.js